import Service from 'additiv-services';
import { getQueryStringByObject } from 'additiv-services/utils/queryUtils';
import { getCustomServiceLayerHeader } from 'additiv-services/setup';
import {
    CUSTOM_SERVICE_LAYER_SERVICES,
    getCustomServiceLayerBaseUrl,
} from '../constants';

class CustomSystemMessageServices extends Service {
    static #baseServiceUrl = getCustomServiceLayerBaseUrl(
        CUSTOM_SERVICE_LAYER_SERVICES.SYSTEM_MESSAGES,
    );

    static #baseServiceUrlDefault = getCustomServiceLayerBaseUrl(
        CUSTOM_SERVICE_LAYER_SERVICES.DEFAULT,
    );

    static getSystemMessageDetails({ messageId }) {
        return Service.getRequest(`${this.#baseServiceUrl}/${messageId}`, {
            isSecure: true,
            axiosSetup: { headers: getCustomServiceLayerHeader() },
        });
    }

    static getSystemMessages({ page, pageSize }) {
        const queryString = getQueryStringByObject({
            page,
            pageSize,
        });

        return Service.getRequest(`${this.#baseServiceUrl}?${queryString}`, {
            isSecure: true,
            axiosSetup: { headers: getCustomServiceLayerHeader() },
        });
    }

    static getActiveSystemMessageDetails({ personId, clientApplication }) {
        return Service.getRequest(`${this.#baseServiceUrlDefault}persons/${personId}/system-messages/active/${clientApplication}`, {
            isSecure: true,
            axiosSetup: { headers: getCustomServiceLayerHeader() },
        });
    }

    static checkSystemMessageTimeRange({
        startDateTime, endDateTime, platform = 3, idToSkip = 0,
    }) {
        return Service.postRequest(
            `${this.#baseServiceUrl}/check/time-range`,
            {
                startDateTime, endDateTime, platform, idToSkip,
            },
            {
                isSecure: true,
                axiosSetup: { headers: getCustomServiceLayerHeader() },
            },
        );
    }

    static createSystemMessage({ ...payload }) {
        return Service.postRequest(
            `${this.#baseServiceUrl}/`,
            payload,
            {
                isSecure: true,
                axiosSetup: { headers: getCustomServiceLayerHeader() },
            },
        );
    }

    static markSystemMessageAsRead({ personId, messageId }) {
        return Service.postRequest(
            `${this.#baseServiceUrlDefault}persons/${personId}/system-messages/${messageId}/read`,
            {},
            {
                isSecure: true,
                axiosSetup: { headers: getCustomServiceLayerHeader() },
            },
        );
    }

    static updateSystemMessage({ messageId, ...payload }) {
        return Service.putRequest(
            `${this.#baseServiceUrl}/${messageId}`,
            payload,
            {
                isSecure: true,
                axiosSetup: { headers: getCustomServiceLayerHeader() },
            },
        );
    }

    static deactivateSystemMessage({ messageId }) {
        return Service.postRequest(
            `${this.#baseServiceUrlDefault}system-messages/${messageId}/deactivate`,
            {},
            {
                isSecure: true,
                axiosSetup: { headers: getCustomServiceLayerHeader() },
            },
        );
    }

    static deleteSystemMessage({ messageId }) {
        return Service.deleteRequest(
            `${this.#baseServiceUrl}/${messageId}`,
            {
                isSecure: true,
                axiosSetup: { headers: getCustomServiceLayerHeader() },
            },
        );
    }
}

export default CustomSystemMessageServices;
